'use strict';

import React, { PropTypes } from 'react';
import { keys } from 'underscore';
import ClassNameMixin from '../mixins/ClassNameMixin';
import PureRenderMixin from '../mixins/PureRenderMixin';

require('./Icon.less');

const ICON_MAP = {
  'arrowDown': require('./icons/ArrowDown'),
  'arrowLeft': require('./icons/ArrowLeft'),
  'arrowRight': require('./icons/ArrowRight'),
  'arrowUp': require('./icons/ArrowUp'),
  'audio': require('./icons/Audio'),
  'backward': require('./icons/Backward'),
  'check': require('./icons/Check'),
  'chrome': require('./icons/Chrome'),
  'clock': require('./icons/Clock'),
  'cross': require('./icons/Cross'),
  'email': require('./icons/Email'),
  'eye': require('./icons/Eye'),
  'eyeCrossed': require('./icons/EyeCrossed'),
  'facebook': require('./icons/Facebook'),
  'firefox': require('./icons/Firefox'),
  'forward': require('./icons/Forward'),
  'google': require('./icons/Google'),
  'grid': require('./icons/Grid'),
  'ie': require('./icons/IE'),
  'image': require('./icons/Image'),
  'instagram': require('./icons/Instagram'),
  'invite': require('./icons/Invite'),
  'like': require('./icons/Like'),
  'link': require('./icons/Link'),
  'list': require('./icons/List'),
  'logo': require('./icons/Logo'),
  'more': require('./icons/More'),
  'notification': require('./icons/Notification'),
  'opera': require('./icons/Opera'),
  'pause': require('./icons/Pause'),
  'pinterest': require('./icons/Pinterest'),
  'play': require('./icons/Play'),
  'plus': require('./icons/Plus'),
  'poster': require('./icons/Poster'),
  'safari': require('./icons/Safari'),
  'search': require('./icons/Search'),
  'set': require('./icons/Set'),
  'settings': require('./icons/Settings'),
  'share': require('./icons/Share'),
  'spinner': require('./icons/Spinner'),
  'stamp': require('./icons/Stamp'),
  'text': require('./icons/Text'),
  'trending': require('./icons/Trending'),
  'tumblr': require('./icons/Tumblr'),
  'twitter': require('./icons/Twitter'),
  'video': require('./icons/Video'),
  'zine': require('./icons/Zine'),
  'collect': require('./icons/Collect')
};

const ICON_KEYS = keys(ICON_MAP);

const Icon = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  statics: {
    ICON_KEYS: ICON_KEYS
  },

  propTypes: {
    name: PropTypes.oneOf(ICON_KEYS).isRequired,
    size: PropTypes.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large']).isRequired,
    mode: PropTypes.oneOf(['fill', 'stroke']),
    margin: PropTypes.oneOf(['left', 'right']),
    className: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func
  },

  className: 'Icon',

  getDefaultProps() {
    return {
      size: 'small',
      mode: 'fill'
    };
  },

  getCSSModifiers() {
    var modifiers = [this.props.size, this.props.name, this.props.mode];

    if (this.props.margin) {
      var marginSide = this.props.margin;
      modifiers.push('margin' + marginSide[0].toUpperCase() + marginSide.slice(1));
    }

    return modifiers;
  },

  render() {
    var NamedIcon = ICON_MAP[this.props.name],
        iconSize = this.props.size;

    if (iconSize === 'xsmall' || iconSize === 'xxsmall') {
      iconSize = 'small';
    }

    return (
      <div className={this.getClassName()}
           style={this.props.style}
           onClick={this.props.onClick}>
        <NamedIcon size={iconSize} />
      </div>
    );
  }
});

export default Icon;



/** WEBPACK FOOTER **
 ** ./atoms/Icon.jsx
 **/